import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { ImageField, ImagesField } from "@/admin/ImageFields";

const input = "w-full border border-[#e2dcd4] bg-white px-3 py-2.5 text-sm focus:outline-none focus:border-[#1f402b]";

function CsvInput({ value, set, id }) {
  const [raw, setRaw] = useState((value || []).join(", "));
  const change = (v) => {
    setRaw(v);
    set(v.split(",").map((s) => s.trim().toUpperCase()).filter(Boolean));
  };
  return <input value={raw} onChange={(e) => change(e.target.value)} className={input} data-testid={id} />;
}

function Field({ f, value, set }) {
  const id = `field-${f.k}`;
  if (f.type === "switch") return <Switch checked={!!value} onCheckedChange={set} data-testid={id} />;
  if (f.type === "image") return <ImageField value={value} onChange={set} />;
  if (f.type === "images") return <ImagesField value={value || []} onChange={set} />;
  if (f.type === "textarea") return <textarea rows={f.rows || 4} value={value || ""} onChange={(e) => set(e.target.value)} className={input} data-testid={id} />;
  if (f.type === "select")
    return (
      <select value={value || f.default} onChange={(e) => set(e.target.value)} className={input} data-testid={id}>
        {f.options.map((o) => <option key={o}>{o}</option>)}
      </select>
    );
  if (f.type === "csv") return <CsvInput value={value} set={set} id={id} />;
  return <input type={f.type === "date" ? "date" : "text"} required={f.required} value={value || ""} onChange={(e) => set(e.target.value)} className={input} data-testid={id} />;
}

export default function ItemForm({ config, item, onClose, onSave }) {
  const init = item || Object.fromEntries(config.fields.filter((f) => f.default !== undefined).map((f) => [f.k, f.default]));
  const [data, setData] = useState(init);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await onSave(data).finally(() => setSaving(false));
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto bg-[#fcfbfa] rounded-none" data-testid="admin-item-form">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#1f402b]">{item ? "Edit" : "New"} {config.singular}</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5">
          {config.fields.map((f) => (
            <div key={f.k} className="block">
              <span className="block font-mono-k text-[10px] uppercase tracking-widest text-[#5a665e] mb-1.5">{f.label}</span>
              <Field f={f} value={data[f.k]} set={(v) => setData((d) => ({ ...d, [f.k]: v }))} />
            </div>
          ))}
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onClose} className="px-5 py-2.5 text-sm border border-[#e2dcd4]" data-testid="admin-form-cancel">Cancel</button>
            <button disabled={saving} className="px-6 py-2.5 text-sm bg-[#1f402b] text-white hover:bg-[#2c5a3d] disabled:opacity-60" data-testid="admin-form-save">
              {saving ? "Saving…" : "Save"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
